import React, { useState } from 'react'
import './TravelFinished.min.css'


interface Attraction {
  id: number;
  name: string;
  isDone: number;
}

interface Groups {
  id: number;
  name: string;
}

interface Props {
  attraction: Attraction;
  group: Groups;

}


const AttractionsTravelEnd: React.FC<Props> = ({ attraction }) => {

  return (

    <div className='list'>
      <div className='done'>

        {attraction.isDone == 1 ? (
          <span>
            <input type='checkbox' checked={true} readOnly></input>
            <s className='text'> {attraction.name} </s>
          </span>
        ) : (
          <span>
            <input type='checkbox' checked={false} readOnly></input>
            <span className='text'> {attraction.name}</span>
          </span>
        )
        }

      </div>
    </div>
   
  )
}

export default AttractionsTravelEnd